import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect, useRef, useState } from "react"
import { Context } from ".."

import useWindowDimensions from "../core/hooks/useWindowDimensions"
import { useFetching } from "../core/hooks/useFetching"

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { isElementInViewport, prevent } from "../core/utils/utils"

import styles2 from "./Studios/Studios.module.scss"
import styles from "../styles/Home.module.scss"
import Breadcrumbs from "./_shared/Breadcrumbs/Breadcrumbs"
import HomeCardWrap from "./_shared/HomeCardWrap/HomeCardWrap"
import { ApiService } from "../core/api/api"
import { useLocation, useNavigate } from "react-router-dom"
import { XProduct } from "../core/models/store/product"
import RubbleIcon from "../components/icons/RubbleIcon"
import { Carousel, message, Popover, Rate } from "antd"
import { FormattedMessage, useIntl } from "react-intl"
import { LOCALES } from "../core/i18n/locales"
import SearchLine from "./_shared/SearchLine/SearchLine"

interface IArticle {
  id?: number
  image: string | null
  frame?: string
  title: string
  subtitle: string
  text: string
  source: string | null
  link: string | null
}

const ArticlesData: IArticle[] = []

const ShopsData: any[] = []

const Home: FC = () => {

  const { formatMessage: f } = useIntl()

  const { store, shopStore, studioStore } = useContext(Context)
  const { width } = useWindowDimensions()

  const location = useLocation()

  const navigate = useNavigate()

  const swiperEl1 = useRef(null as any)
  const swiperEl2 = useRef(null as any)
  const swiperEl3 = useRef(null as any)

  const [swiper1, setSwiper1] = useState({} as any)
  const [swiper2, setSwiper2] = useState({} as any)
  const [swiper3, setSwiper3] = useState({} as any)

  const [userName, setUserName] = useState("")
  const [userCity, setUserCity] = useState("")
  const [userPhone, setUserPhone] = useState("")

  const [userToken, setUserToken] = useState("")

  const [selImg, setSelImg] = useState("0")

  const [clusterPoints, setClusterPoints] = useState([
    [55.686852, 37.852365], [47.232634, 39.625379], [45.119326, 38.927496], [45.097692, 38.973570]
  ] as number[][])

  const [articles, setArticles] = useState([] as IArticle[])

  const [services, setServices] = useState([] as any[])

  const [category, setCategory] = useState(null as any | null)
  const [categoryStore, setCategoryStore] = useState(null as any | null)

  const [fetchServices] = useFetching(async () => {
    const resServs = await ApiService.studios.getServices({
      search: studioStore.serviceSearch,
      limit: 100,
      offset: 0
    })

    let srvs: any[] = resServs.data.services

    setServices(prev => prev = srvs)
  })

  const [fetchData, isDataLoading, errorData] = useFetching(async () => {
    let lst: IArticle[] = []

    lst = ArticlesData

    setArticles(prev => prev = lst)
  })

  const [fetchStudios] = useFetching(async () => {
    // const res = await ApiService.studios.getStudios({
    //   country_id: studioStore.selCountry == null ? 1 : studioStore.selCountry.id,
    //   city_id: studioStore.selectedCity == null ? 0 : studioStore.selectedCity.id,
    //   page: studioStore.pageIndex,
    //   limit: studioStore.pageLimit,
    //   search: studioStore.search,
    //   category: studioStore.category,
    //   order: studioStore.order,
    //   order_by: studioStore.orderBy,
    //   status: studioStore.status,
    //   date: studioStore.searchDate,
    //   time: studioStore.searchTime,
    //   service: studioStore.searchService
    // })

    // studioStore.setTotalStudios(res.data.total)
    // studioStore.setStudios(res.data.studios)

    const res = await ApiService.studios.getNewStudios(studioStore.selCountry != null ? studioStore.selCountry.id : 0)


    let studiosLst: any[] = res.data.studios

    studiosLst = studiosLst.map(v => {
      let city = studioStore.cities.find(ct => ct.id == v.city_id)
      return { ...v, city, imgs: v.images2.split(";"), sel_image: v.images2 != "" ? v.images2.split(";")[0] : "" }
    })

    studioStore.setNewStudios(studiosLst)
  })

  const runAnimations = () => {

  }

  const openForm = (title: string) => {
    store.setFormTitle(title)
    store.setIsFormVisible(true)
  }

  const getCountryName = (name: string) => {
    if (store.locale != LOCALES.RUSSIAN) {
      return name
    }

    let newName = `${name}`
    let last = newName[newName.length - 1]

    if (last == "я") {
      last = "и"
    } else if (last == "д" || last == "н") {
      last += "е"
    }

    newName = newName.slice(5, newName.length - 1)

    return `${newName.slice(0, newName.length)}${last}`
  }

  const runOpacity = (el: HTMLElement | null, delay: number = 0, asc: number = 0) => {
    if (el != null) {
      // if (width <= 960) {
      //   asc = -40;
      // }

      if (el.style.opacity == "") {
        el.style.opacity = `0`;
      }

      if (isElementInViewport(el)) {
        let dell = window.innerHeight - ((el.getBoundingClientRect().y + el.getBoundingClientRect().height) - delay + asc);
        let spl = dell / 100;

        if (el.style.opacity == "") {
          el.style.opacity = `${spl}`;
        } else {

          el.style.opacity = `${spl}`;
        }
      } else {
        if (parseInt(el.style.opacity) == 0) {
          el.style.opacity = `0`;
        }
      }
    }
  }

  const runBottomOpacity = (el: HTMLElement | null, delay: number = 0, asc: number = 0) => {
    if (el != null) {
      // if (width <= 960) {
      //   delay = 40;
      // }

      if (el.style.transform == "") {
        el.style.transform = "translateY(35px)";
      }

      if (el.style.opacity == "") {
        el.style.opacity = "0";
      }

      if (isElementInViewport(el)) {
        let dell = window.innerHeight - ((el.getBoundingClientRect().y + el.getBoundingClientRect().height) - delay + asc);
        let spl = (dell) / 100;
        if (spl > parseInt(el.style.opacity)) {
        }
        el.style.opacity = `${spl}`;

        let ix = ((dell) / 4) - 35;

        if (ix > parseInt(el.style.bottom.replace("px", ""))) {

        }
        if (ix < 0) {
          el.style.transform = `translateY(${-ix}px)`;
        } else {
          el.style.transform = `translateY(0px)`;
        }
      } else {
        if (el.style.opacity == "0") {
          el.style.opacity = `0`;
          el.style.transform = "translateY(35px)";
        }
      }
    }
  }

  const modifyName = (name: string) => {
    if (name.includes("Запись подкастов")) {
      return "Студии записи подкастов"
    } else if (name.includes("Звукозапись")) {
      return "Студии звукозаписи"
    } else if (name.includes("Запись вебинара")) {
      return "Студии записи вебинара/курса"
    } else if (name.includes("коротких видео")) {
      return "Студии записи коротких видео для социальных сетей"
    }

    return name
  }

  const getFinalPrice = (product: XProduct) => {
    if (product.compound == "item") {
      return product.price
    } else {
      return product.price / 10
    }
  }

  const updateSelImage = (id: number, image: string) => {
    let prev: any[] = [...studioStore.newStudios]
    let lst: any[] = []

    prev.forEach(st => {
      let obj: any = { ...st }
      if (st.id == id) {
        obj.sel_image = image
      }
      lst.push(obj)
    })

    if (studioStore.selStudio != null) {
      let ex = lst.find(v => v.id == studioStore.selStudio.id)
      if (ex != undefined) {
        studioStore.setSelStudio(ex)
      }
    }

    studioStore.setNewStudios(lst)
  }

  const getSmallestPrice = (servs: any[]) => {
    let sum = 0
    servs.forEach(element => {
      if (sum == 0) {
        sum = element.price
      } else {
        if (sum > element.price) {
          sum = element.price
        }
      }
    })
    return sum
  }

  useEffect(() => {

    fetchData()
    fetchServices()
    setTimeout(() => {
      fetchStudios()
    }, 1000)

    setTimeout(() => {
      runAnimations()
    }, 400)

    const onScroll = (event: any) => {
      const scrollTop = event.target.scrollTop


    }

    if (location.hash != "") {
      setTimeout(() => {
        const hsh = document.querySelector(location.hash)
        if (hsh != null) {
          hsh.scrollIntoView({
            behavior: 'smooth',
            // block: 'start'
          })
        }
      }, 300)
    }

    document.getElementById("root")!.addEventListener('scroll', onScroll)

    return () => {
      document.getElementById("root")!.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <>
      <HomeCardWrap>
        <div className={styles.breadcrumbs}>
          <Breadcrumbs />
        </div>

        {studioStore.selCountry != null ? <>
          <div className="main_wrapper">

            <div className={styles.head}>
              <div className="container">
                <div className="row">
                  {width < 768 ? <div className="col-12 col-md-6">
                    <div className={styles.xcarousel}>
                      <Carousel arrows dots={false} autoplay autoplaySpeed={3000}>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/1.png)` }}></div>
                        </div>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/2.jpg)` }}></div>
                        </div>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/3.jpg)` }}></div>
                        </div>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/4.jpg)` }}></div>
                        </div>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/5.jpg)` }}></div>
                        </div>
                      </Carousel>
                    </div>
                  </div> : <></>}
                  <div className="col-12 col-md-6">
                    <strong><FormattedMessage id="home_title" /></strong>
                    <h1><FormattedMessage id="home_subtitle" /> {store.locale == LOCALES.RUSSIAN ? "в" : "in"} {getCountryName(store.locale == LOCALES.RUSSIAN ? studioStore.selCountry.name : studioStore.selCountry.name_en)}</h1>
                    <p><FormattedMessage id="home_text" /></p>

                    {/* <div className={styles.action}>
                  <a href="/studios"><FormattedMessage id="home_action" /></a>
                </div> */}
                  </div>
                  {width > 768 ? <div className="col-12 col-md-6">
                    <div className={styles.xcarousel}>
                      <Carousel arrows dots={false} autoplay autoplaySpeed={3000}>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/1.png)` }}></div>
                        </div>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/2.jpg)` }}></div>
                        </div>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/3.jpg)` }}></div>
                        </div>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/4.jpg)` }}></div>
                        </div>
                        <div>
                          <div className={styles.ximage} style={{ backgroundImage: `url(/assets/images/home/head/5.jpg)` }}></div>
                        </div>
                      </Carousel>
                    </div>
                  </div> : <></>}
                  <div className="col-12">
                    <SearchLine
                      categories={studioStore.allCats}
                      services={services}
                      scrollXTop={525}
                      cities={studioStore.cities}
                      onCitySelected={(city) => {
                        let ex = studioStore.cities.find(v => v.name == city)
                        if (ex != undefined) {
                          studioStore.setSelectedCity(ex)
                          studioStore.setSelectedCityName(ex.name)
                          // navigate(`/studios/${ex.code}`)
                        }

                        // fetchData()
                      }}
                      onCatSelected={() => {
                        // navigate(`/${studioStore.categorySN}`)
                        // setTimeout(() => {

                        // }, 500);
                      }}
                      onSearch={(city, cat, serv, date, time) => {

                        let navi = location.pathname
                        let naviParams = ""

                        if (city == null || city == "" || city == " ") {
                          return message.error(store.locale == LOCALES.RUSSIAN ? "Выберите город для поиска..." : "Select a city to search...")
                        } else {
                          let ex = studioStore.cities.find(v => (store.locale == LOCALES.RUSSIAN ? v.name : v.name_en) == city)
                          if (ex != undefined) {
                            studioStore.setSelectedCity(ex)
                            studioStore.setSelectedCityName(ex.name)
                            if (studioStore.selectedCity == null) {
                              // navigate(`/studios/${ex.code}`)
                            }

                            navi = `/studios/${ex.code}`
                            if (cat == null) {
                              // studioStore.setCategory("")
                              setTimeout(() => {
                                navigate(`/studios/${ex.code}`)
                              }, 500)
                            } else {
                              // studioStore.setCategory(cat)
                              if (cat != "") {
                                // naviParams = `?cat=${cat}`
                                navi = `/studios/${ex.code}/${studioStore.categorySN}`
                                setTimeout(() => {
                                  navigate(`/studios/${ex.code}/${studioStore.categorySN}`)
                                }, 500)
                              }
                            }
                          }
                        }

                        // navigate(navi)
                        // window.location.href = `https://${window.location.hostname}${navi}`

                        if (serv == null) {
                          studioStore.setSearchService("")
                        } else {
                          studioStore.setSearchService(serv)
                        }

                        if (date == null) {
                          studioStore.setSearchDate("")
                        } else {
                          studioStore.setSearchDate(date)
                        }

                        // fetchData()
                      }} />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.features} style={{ paddingTop: "50px" }}>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h2><FormattedMessage id="home_why" /></h2>

                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className={styles.fcard}>
                          <h3><FormattedMessage id="home_why_b1" /></h3>
                          <p><FormattedMessage id="home_why_b1_txt" /></p>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className={styles.fcard}>
                          <h3><FormattedMessage id="home_why_b2" /></h3>
                          <p><FormattedMessage id="home_why_b2_txt" /></p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-4">
                        <div className={styles.fcard + " " + styles.fixed}>
                          <h3><FormattedMessage id="home_why_b3" /></h3>
                          <p><FormattedMessage id="home_why_b3_txt" /></p>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className={styles.fcard + " " + styles.fixed}>
                          <h3><FormattedMessage id="home_why_b4" /></h3>
                          <p><FormattedMessage id="home_why_b4_txt" /></p>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className={styles.fcard + " " + styles.fixed}>
                          <h3><FormattedMessage id="home_why_b5" /></h3>
                          <p><FormattedMessage id="home_why_b5_txt" /></p>
                        </div>
                      </div>
                    </div>

                    <p className={styles.cntrx}><FormattedMessage id="home_why_txt" /></p>

                    <div className={styles.action + " " + styles.full}>
                      <a href="/studios"><FormattedMessage id="home_action" /> {store.locale == LOCALES.RUSSIAN ? "в" : "in"} {getCountryName(store.locale == LOCALES.RUSSIAN ? studioStore.selCountry.name : studioStore.selCountry.name_en)}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.new_studios}>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h2 style={{ display: "flex", justifyContent: "center" }}>{store.locale == LOCALES.RUSSIAN ? "Новые студии" : "New studios"}</h2>

                    <div style={{ position: "relative", marginTop: "24px" }}>
                      <div className={styles2.blog_list} style={{ opacity: studioStore.newStudios.length == 0 ? "0" : "1", display: "block" }}>
                        <Carousel arrows slidesToShow={width > 768 ? 3 : 1} slidesToScroll={1} dots={false} autoplay autoplaySpeed={3000}>
                          {studioStore.newStudios.map(studio => <div>
                            <a id={`studio_${studio.id}`} href={`/studios/${studio.city != undefined ? studio.city.code : "moscow"}/${studio.link_name}`} className={styles2.blog_item + " " + styles.ns_item} style={{ width: "96%", boxShadow: "none", transform: "none" }}>
                              <a className={styles2.blog_item__image} style={width > 0 ? {
                                backgroundImage: `url(${studio.images2 != "" ? studio.sel_image : "/assets/images/studio_placeholder.jpg"})`
                              } : (studio.imgs != undefined && studio.imgs.length < 2 ? { backgroundImage: `url(${studio.images2 != "" ? studio.sel_image : "/assets/images/studio_placeholder.jpg"})` } : {})}>
                                {studio.images2 != "" && studio.images2.split(";").length > 1 && width <= 768 ? <>
                                  <div className={styles2.indicate_arrows}>
                                    <div onClick={(ev) => {
                                      prevent(ev)
                                      const fIx = studio.imgs.findIndex((im: any) => im == studio.sel_image)
                                      let ix = fIx - 1
                                      if (ix < 0) {
                                        ix = studio.imgs.length - 1
                                      }
                                      updateSelImage(studio.id, studio.imgs[ix])
                                    }}><i className="fas fa-chevron-left"></i></div>
                                    <div onClick={(ev) => {
                                      prevent(ev)
                                      const fIx = studio.imgs.findIndex((im: any) => im == studio.sel_image)
                                      let ix = fIx + 1
                                      if (fIx >= studio.imgs.length - 1) {
                                        ix = 0
                                      }
                                      updateSelImage(studio.id, studio.imgs[ix])
                                    }}><i className="fas fa-chevron-right"></i></div>
                                  </div>
                                </> : <></>}

                                {studio.images2 != "" && studio.images2.split(";").length > 1 && width > 768 ? <div className={styles2.indicate}>
                                  {studio.images2.split(";").map((img: string) => <div className={styles2.i_item + (studio.sel_image == img ? " " + styles2.active : "")} onMouseEnter={() => {
                                    updateSelImage(studio.id, img)
                                  }} onClick={(ev) => {
                                    if (width < 768) {
                                      prevent(ev)
                                      updateSelImage(studio.id, img)
                                    }
                                  }}><div></div></div>)}
                                </div> : <></>}
                              </a>
                              <div className={styles2.blog_item__data}>
                                <a className={styles2.title} href={`/studios/${studio.city != undefined ? studio.city.code : "moscow"}/${studio.link_name}`}>{studio.name}</a>
                                <a className={styles2.desc} href={`/studios/${studio.city != undefined ? studio.city.code : "moscow"}/${studio.link_name}`}>{studio.address}</a>
                                <div className={styles2.bottom_bar + " " + styles.bmb}>
                                  <div className={styles2.bb_views}><Rate className="xrate_studio_card" allowHalf={true} defaultValue={studio.rating == null ? 5 : studio.rating} value={studio.rating == null ? 5 : studio.rating} disabled /></div>
                                  <Popover trigger="hover" title={f({ id: "studios_comeback" })}><div className={styles2.bb_users}><span><i className="fas fa-user"></i></span> {studio.clients_back}</div></Popover>
                                  <div className={styles2.bb_go}>
                                    <a href={`/studios/${studio.city != undefined ? studio.city.code : "moscow"}/${studio.link_name}`}>{studio.services.length > 0 ? <>{store.locale == "ru-RU" ? "от" : "from"} <span>{getSmallestPrice(studio.services)}</span> {studioStore.selCountry != null ? studioStore.selCountry.currency : "руб"}</> : (store.locale == "ru-RU" ? "Подробнее" : "More")} <b><i className="far fa-chevron-right"></i></b></a>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>)}
                        </Carousel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.categories}>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h2><FormattedMessage id="home_cats" /></h2>

                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className={styles.cats}>
                          {studioStore.allCats.slice(0, 8).map((cat, ix) => <div className={styles.cat_item} onClick={() => {
                            studioStore.setSelectedCat(cat)
                            setTimeout(() => {
                              // navigate("/" + cat.subname)
                              window.location.href = `/${cat.subname}`
                            }, 500)
                          }} onMouseEnter={() => studioStore.setSelCat(ix)} onMouseLeave={() => studioStore.setSelCat(0)}><span>{store.locale == LOCALES.RUSSIAN ? modifyName(cat.name) : cat.name_en}</span><b><i className="fal fa-circle-arrow-right"></i></b></div>)}
                        </div>

                        <a href="/studios"><FormattedMessage id="home_cats_all" /> <b><i className="far fa-arrow-right-long"></i></b></a>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className={styles.cat_preview}>
                          {studioStore.allCats.map((cat, ix) => <div style={{ backgroundImage: `url(${cat.image})`, opacity: ix == studioStore.selCat ? "1" : "0" }}></div>)}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className={styles.partners}>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h2><FormattedMessage id="home_partners" /></h2>

                    {width > 768 ? <>
                      <div className={styles.plist}>
                        <a href="https://music.yandex.ru/" rel="nofollow"><img src="/assets/images/home/partners/yandex-music.png" /></a>
                        <a href="https://music.vk.com/" rel="nofollow"><img src="/assets/images/home/partners/vk_music.png" /></a>
                        <a href="https://zvuk.com/" rel="nofollow"><img src="/assets/images/home/partners/zvuk_sber.png" /></a>
                        <a href="https://dzen.ru/" rel="nofollow"><img src="/assets/images/home/partners/dzen.png" /></a>
                      </div>
                      {/* <div className={styles.plist + " " + styles.last}>
                    <a href="#"><img src="https://optim.tildacdn.com/tild3166-6531-4536-b865-353065336335/-/resize/474x/-/format/webp/Mellstroy_1.png" /></a>
                    <a href="#"><img src="https://zipm.ru/pictures/logo.png" /></a>
                    <a href="#"><img src="https://www.astro-seek.com/seek-images/bannery_2015/seek_logo_200_eye_ru.gif" /></a>
                  </div> */}
                    </> : <>
                      <div className={styles.plist}>
                        <a href="https://music.yandex.ru/" rel="nofollow"><img src="/assets/images/home/partners/yandex-music.png" /></a>
                        <a href="https://music.vk.com/" rel="nofollow"><img src="/assets/images/home/partners/vk_music.png" /></a>
                      </div>
                      <div className={styles.plist}>
                        <a href="https://zvuk.com/" rel="nofollow"><img src="/assets/images/home/partners/zvuk_sber.png" /></a>
                        <a href="https://dzen.ru/" rel="nofollow"><img src="/assets/images/home/partners/dzen.png" /></a>
                      </div>
                    </>}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </> : <></>}
      </HomeCardWrap>
    </>
  )
}

export default observer(Home)